// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Wxv6m","loading__icon":"Loading_loading__icon__k3iB8"};